import { connect }         from 'react-redux';
import Errors              from '../../../errors';
import { login }           from './login-dux';
import {
    dismissError,
    dismissAllErrors }     from '../../../errors-dux';
import { setUserData }     from '../../../user-dux';
import { fetchBundleData } from '../../../client-dux';
import { routeTo }         from '../../../routing-dux';
import Login               from './login.jsx';

export default connect(
    // mapStateToProps
    state => {
      return {
            preActivationLoginAttemptFlag: state.activationData.preActivationLoginAttemptFlag,
            authenticated: state.userData.authenticated,
            errors: Errors.getByType( state, Errors.ERROR_LOGIN ),
            loggingIn: state.loginData.busy,
            done: state.userData.authenticated,
            localeOptions: state.clientData.localeList,
            locale: state.userData.locale,
            bundleList: state.clientData.bundleList
        };
    },
    // mapDispatchToProps
    {
        login,
        dismissError,
        dismissAllErrors,
        setUserData,
        fetchBundleData,
        routeTo
    }
)( Login );
